const DownloadAll = function() {

  const template = `
    <button ng-show="record.state == 'OK'" type="button"
      class="btn btn-xs sol-button download-all">
      <a class="button-override"
        ng-href="{{ record.attachmentUrl }}">
        Download All Related Documents
      </a>
    </button>
  `

  return {
    template: template,
    scope: {
      record: '='
    }
  }
}

export default DownloadAll
